import {ComplianceTicket, ComplianceTicketFragmentFragment} from "../../../__generated__/graphql/types";
import {ComplianceTicketFormData, VeriflytTicketFormFields} from "./types";
import {createFormField, createFormFields, getLabelInValue, LabelInValue} from "../../../common/form";
import {Moment} from "moment";
import {momentOrNull} from "../../../common/util";
import uuidv4 from 'uuid/v4';
import {ComplianceEditorApi, State} from "./state";
import {CollapsePanelProps, CollapseProps} from "antd/lib/collapse";

/**
 * Converts a ComplianceTicket object into form fields and converts dates to moments
 * @param ticket ComplianceTicket to enhance
 * @param internalId Optionally choose an internal ID, otherwise one is generated.
 * @private
 */
export function toFormData(ticket: ComplianceTicketFragmentFragment | ComplianceTicketFormData, internalId?: string): ComplianceTicketFormData {
    if (VeriflytTicketFormFields.ticketTemplateIDAndName in ticket){
        return ticket;
    }

    const nonFormTicket = ticket as ComplianceTicket;

    return {
        _id: nonFormTicket._id,
        internalId: internalId || uuidv4(),
        ticketTemplateDoc: ticket.ticketTemplateDoc,
        completionDate: createFormField<Moment>(momentOrNull(nonFormTicket.completionDate)),
        expirationDate: createFormField<Moment>(momentOrNull(nonFormTicket.expirationDate)),
        ticketTemplateIDAndName: createFormField<LabelInValue>(getLabelInValue(nonFormTicket.ticketTemplateDoc, 'onScreenName')),
        result_passed: createFormField<number>(
            nonFormTicket.result_passed ? 1 : 0
        )
    }
}

export function getCollapsePanelKey(ticket: ComplianceTicketFormData): string {
    return ticket.internalId;
}